import { useSearchParams } from 'react-router-dom';
import { ElectionPage } from './index.js';
import { ElectionMapExplorer } from './second-turn.js';
import { ElectionPanorama } from './panorama.js';
import { Panel } from '../../components/ui.js';
import { useElectionLeadAlerts } from './lead-alerts.js';

export function ElectionExperience({ turno }: { turno: 1 | 2 }) {
  const [params, setParams] = useSearchParams();
  const panorama = params.get('visualizacao') !== 'tradicional';
  const alerts = useElectionLeadAlerts(params, turno);
  const selectView = (nextView: 'standard' | 'panorama') => setParams((current) => {
    const next = new URLSearchParams(current);
    if (nextView === 'panorama') next.delete('visualizacao');
    else next.set('visualizacao', 'tradicional');
    return next;
  }, { replace: true });
  const controls = <div className="election-view-switch" role="group" aria-label="Visualização da apuração">
    <button type="button" aria-pressed={!panorama} onClick={() => selectView('standard')}><svg viewBox="0 0 20 20" aria-hidden="true"><rect x="2" y="2" width="16" height="16" rx="2" /><path d="M2 7h16M10 7v11" /></svg>Tradicional</button>
    <button type="button" aria-pressed={panorama} onClick={() => selectView('panorama')}><svg viewBox="0 0 20 20" aria-hidden="true"><rect x="1" y="3" width="18" height="14" rx="2" /><path d="M6 3v14M14 3v14" /></svg>Apurações detalhadas</button>
  </div>;

  const mapExplorer = panorama
    ? <Panel className="election-panorama-card"><div className="section-heading panorama-card-heading"><div><h2>Mapa da apuração · {turno}º turno</h2><p>Explore a apuração por cargo, estado e município. Passe o mouse para consultar o resumo de cada localidade.</p></div>{controls}</div><ElectionPanorama turno={turno} /></Panel>
    : <ElectionMapExplorer embedded turno={turno} headerControls={controls} />;
  return <><ElectionPage turno={turno} mapExplorer={mapExplorer} />{alerts.notification}</>;
}
